









import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'i-branch',

})
export default class IBranch extends Vue {

  @Prop({type: [String], default: '#000'}) protected color!: string

}

